import React     from 'react';
import PropTypes from 'prop-types';

// jodit editor lib
import 'jodit';
import 'jodit/build/jodit.min.css';
import JoditEditor from 'jodit-react';
// -----------------------------------------------

// import './editorStyle.sass';

// material-ui components
import Dialog        from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
// -----------------------------------------------

class InputEditor extends React.Component {
  static inputType = 'WYSIWYG';

  static propTypes = {
    'state-name': PropTypes.string.isRequired,
    'name':         PropTypes.string.isRequired,
  };

  _getEditorConfig = () => {
    const defaultEditorConfig = {
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      globalFullsize: false,
      editorCssClass: 'duobr-jodit-editor',
      placeholder: 'Descrição',
      buttons: [
        'undo', 'redo', 'bold', 'strikethrough', 'underline', 'italic', '|',
        'ul', 'ol', '|',
        'outdent', 'indent', 'align', 'fontsize', 'paragraph', '|',
        'image', 'link', 'hr', 'eraser', '|',
        {
          name: 'customFullSize',
          icon: 'fullsize',
          exec: this.toggleFullscreen
        }, 'source',
      ],
      buttonsMD: [
        'undo', 'redo', 'bold', 'strikethrough', 'underline', 'italic', '|',
        'ul', 'ol',
        'outdent', 'indent', 'align', 'fontsize', 'paragraph',
        'image', 'link', 'hr', 'eraser',
        {
          name: 'customFullSize',
          icon: 'fullsize',
          exec: this.toggleFullscreen
        }, 'source',
      ],
      buttonsSM: [
        'undo', 'redo', 'bold', 'strikethrough', 'underline', 'italic', '|',
        'ul', 'ol',
        'outdent', 'indent', 'align',
        'image', 'link',
        {
          name: 'customFullSize',
          icon: 'fullsize',
          exec: this.toggleFullscreen
        },
      ],
      buttonsXS: [
        'undo', 'redo', 'bold', 'strikethrough', 'underline', 'italic', '|',
        'ul', 'ol', '|',
        'image', 'link',
        {
          name: 'customFullSize',
          icon: 'fullsize',
          exec: this.toggleFullscreen
        },
      ],
      // uploader: {
      //   url: Routes.upload_files_path(),
      //   headers: {
      //     'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      //   },
      //   process: function (resp) {
      //     const filterSuccess = (fl) => fl.success;
      //     const filterError   = (fl) => !fl.success;
      //     return {
      //          files:   resp.files.filter(filterSuccess).map( (fl) => fl.url ) || [],
      //          path:    '',
      //          baseurl: '',
      //          error:   resp.files.filter(filterError).map( (fl) => fl.msg ).flat(),
      //          msg:    ['']
      //      };
      //   },
      //   isSuccess: function (resp) {
      //     return resp.files.length > 0;
      //   },
      //   error: function (e) {
      //     this.jodit.events.fire('errorMessage', ['Arquivo não suportado.']);
      //   }
      // },
      // events: {
      //   getIcon: (name, control, clearName) => {
      //     let code = '';
      //     let classPrefix = 'fa fa-';

      //     switch (clearName) {
      //       case 'redo':
      //         code = 'rotate-right';
      //       break;
      //       case 'ul':
      //         code = 'list-ul';
      //       break;
      //       case 'ol':
      //         code = 'list-ol';
      //       break;
      //       case 'left':
      //         code = 'align-left';
      //       break;
      //       case 'right':
      //         code = 'align-right';
      //       break;
      //       case 'center':
      //         code = 'align-center';
      //       break;
      //       case 'justify':
      //         code = 'align-justify';
      //       break;
      //       case 'fontsize':
      //         code = 'text-height';
      //       break;
      //       case 'hr':
      //         code = 'minus';
      //       break;
      //       case 'customFullSize':
      //         classPrefix = '';
      //         code = 'clip-fullscreen';
      //       break;
      //       case 'source':
      //         code = 'code';
      //       break;
      //       default:
      //         code = name;
      //       break;

      //     }

      //     return `<i style="font-size:14px" class="${classPrefix}${code} fa-xs"></i>`;
      //   }
      // }

    };

    return defaultEditorConfig;
  };

  fullScreenContainer = document.createElement('div');
  toggleFullscreen = () => {
    const {isFullScreen} = this.state;
    if(isFullScreen){
      setTimeout(() => {
        document.body.removeChild(this.fullScreenContainer);
      }, 100);
    }else{
      document.body.appendChild(this.fullScreenContainer);
    }

    this.setState({isFullScreen: !isFullScreen});
  };

  state = {
    isFullScreen:          false,
    joditConfigNormal:     this._getEditorConfig(false),
    joditConfigFullscreen: this._getEditorConfig(true),
  };

  joditNormal = undefined;
  joditFullscreen = undefined;
  setRefNormal = jodit => this.joditNormal = jodit;
  setRefFullscreen = jodit => this.joditFullscreen = jodit;

  handleChange = (value) => {
    const { onChange, 'state-name': stateName } = this.props;
    const fakeEvent = {type: 'change', target: {value: value}};
    onChange({[stateName]: value }, fakeEvent);
  };

  componentDidUpdate(prevProps, prevState) {
    const { isFullScreen } = this.state;

    if(!isFullScreen && prevState.isFullScreen){
      setTimeout(() => {
        this.joditNormal.editor.focus();
      }, 200);
    }else if(isFullScreen && !prevState.isFullScreen){
      setTimeout(() => {
        if(this.joditFullscreen){
          this.joditFullscreen.editor.focus();
        }
      }, 200);
    }
  }

  render() {
    const {
      value,
      name,
    } = this.props;

    const { isFullScreen, joditConfigNormal, joditConfigFullscreen } = this.state;

    return (
      <React.Fragment>
        <div className="duobr-jodit-editor--container">
          <Dialog
            scroll='body'
            container={ () => this.fullScreenContainer }
            fullScreen
            open={isFullScreen}
          >
            <DialogContent>
              <JoditEditor
                editorRef={this.setRefFullscreen}
                value={value}
                config={joditConfigFullscreen}
                onChange={this.handleChange}
              />
            </DialogContent>
          </Dialog>
          <JoditEditor
            editorRef={this.setRefNormal}
            value={value}
            config={joditConfigNormal}
            onChange={this.handleChange}
          />
        </div>
        <textarea name={name} value={value} onChange={ () => {}} style={{display: 'none'}}/>
      </React.Fragment>
    );
  }
}

export default InputEditor;
